/* eslint-disable no-continue */
import { IModuleTile } from '../interfaces/interfaces';

export default function getNextFreeSlot(tileSet: IModuleTile[], w: number): { x: number; y: number } {
  const slot = { x: 0, y: 0 };
  const maxY = Math.max(...tileSet.map((t) => t.layout.y)) + 1;

  for (let y = 0; y <= maxY; y += 1) {
    const rowSetup = tileSet
      .filter((t) => t.layout.y === y)
      .map((t) => {
        return { x: t.layout.x, w: t.layout.w, t };
      });
    for (let x = 0; x < 4; x += 1) {
      const tileOnIndex = rowSetup.filter((rs) => rs.x === x);
      if (!tileOnIndex.length) {
        // is free for 1x1!
        // 2x1 - has free space or next space is blocked?
        if (w === 2 && (x === 3 || rowSetup.filter((rs) => rs.x === x + 1).length)) {
          x = 4;
          continue;
        }
        // 3x1 - has free space or next space is blocked?
        if (
          w === 3 &&
          (x === 2 || rowSetup.filter((rs) => rs.x === x + 1).length || rowSetup.filter((rs) => rs.x === x + 2).length)
        ) {
          x = 4;
          continue;
        }

        slot.x = x;
        slot.y = y;
        return slot;
      }

      if (tileOnIndex[0].w > 1) {
        x += tileOnIndex[0].w - 1;
      }
    }
  }

  return slot;
}
